<template>
    <div class="my-task">
        <div class="task-statistics">
            <div class="progress">
                <div style="padding:12px 0 0 24px;text-align:left;font-size:16px;">我的任务进度</div>
                <ul>
                    <li>
                        <div style="color: rgba(24, 144, 255, 1)">{{taskProgress.onGoingCount}}</div>
                        <div>进行中</div>
                    </li>
                    <li>
                        <div style="color: rgba(255, 195, 0, 1)">{{taskProgress.toCheckCount}}</div>
                        <div>待验收</div>
                    </li>
                    <li>
                        <div style="color: rgba(34, 215, 187, 1)">{{taskProgress.finishCount}}</div>
                        <div>已结束</div>
                    </li>
                    <li>
                        <div style="color: rgba(255, 70, 70, 1)">{{taskProgress.delayCount}}</div>
                        <div>已延期</div>
                    </li>
                    <li>
                        <div style="color: rgba(78, 138, 250, 1)">{{taskProgress.totalCount}}</div>
                        <div>任务总数</div>
                    </li>
                </ul>
            </div>
            <div class="statistics">
                <div style="padding:12px 0 0 24px;text-align:left;font-size:16px;">用户总正确率统计</div>
                <div class="proportion">
                <a-row>
                    <a-col class="list" :span="8">
                    <span>正确率</span>
                    <a-progress type="circle" :percent="correctStatistics.rightRate" strokeColor='#22D7BB'/>
                    </a-col>
                    <a-col class="list" :span="8">
                    <span>存疑率</span>
                    <a-progress type="circle" :percent="correctStatistics.doubtRate" strokeColor='#499DF8'/>
                    </a-col>
                    <a-col class="list" :span="8">
                    <span>错误率</span>
                    <a-progress type="circle" :percent="correctStatistics.errorRate" strokeColor='#FF4646'/>
                    </a-col>
                </a-row>
                </div>
            </div>
        </div>
        <div class="tast-list">
            <div style="padding:0 24px">
                <div class="title">我的任务列表</div>
                <div class="condition-list">
                    <span @click="selectCondition('')" :class="{'active':taskCondition.status==''}">全部</span>
                    <span @click="selectCondition('ON_GOING')" :class="{'active':taskCondition.status=='ON_GOING'}">进行中</span>
                    <span @click="selectCondition('TO_CHECK')" :class="{'active':taskCondition.status=='TO_CHECK'}">待验收</span>
                    <span @click="selectCondition('FINISH')" :class="{'active':taskCondition.status=='FINISH'}">已结束</span>
                    <span @click="selectCondition('DELAY')" :class="{'active':taskCondition.status=='DELAY'}">已延期</span>
                </div>
            </div>
            <a-divider style="margin:10px 0 0px 0;color:#F7F7F7"/>
            <div style="clear:both"></div>
            <div style="padding:24px 24px 50px 24px;">
                <a-table :data-source="data" :pagination='false' :loading="ifShowLoading">
                    <a-table-column key="seriesNo" title="任务编号" data-index="seriesNo">
                        <template slot-scope="text, record">
                        <div>
                            <span @click="viewTaskDetail(record.id)" style="color:rgba(34, 215, 187, 1);cursor:pointer">{{ record.seriesNo }}</span>
                        </div>
                        </template>
                    </a-table-column>
                    <a-table-column key="projectName" title="所属项目" data-index="projectName" />
                    <a-table-column key="status" title="状态" data-index="status">
                        <template slot-scope="text, record">
                        <div>
                            <span style="color:rgba(34, 215, 187, 1)">{{ judgeState(record.status) }}</span>
                        </div>
                        </template>
                    </a-table-column>
                    <a-table-column key="finishWordCount" title="完成进度" data-index="finishWordCount">
                        <template slot-scope="text, record">
                        <div>
                            <span style="display:inline-block;width:34px;">{{record.finishWordCount}}</span>
                            <a-progress style="display:inline-block;width:100px" :percent="record.finishWordCount/record.totalWordCount*100" status="active" :show-info="false" />
                            <span style="display:inline-block;margin-left:10px">{{record.totalWordCount}}</span>
                        </div>
                        </template>
                    </a-table-column>
                    <a-table-column key="income" title="预计收入" data-index="income" />
                    <a-table-column key="userName" title="标注员" data-index="userName" />
                    <a-table-column key="limitDate" title="截止日期" data-index="limitDate" />
                </a-table>
                <div style="font-size:14px;margin-top:16px;float:left">
                    <span style="color:rgba(80, 80, 80, 1)">总计：</span>
                    <span style="color:rgba(24, 144, 255, 1)">{{total}}个</span>
                </div>
                <a-pagination
                    style="float:right;margin-top:16px"
                    v-model="taskCondition.current"
                    :page-size-options="pageSizeOptions"
                    :total="total"
                    show-size-changer
                    :page-size="taskCondition.size"
                    @showSizeChange="onShowSizeChange"
                    @change="onChangeSample"
                    >
                    <template slot="buildOptionText" slot-scope="props">
                        <span>{{ props.value }}条/页</span>
                    </template>
                </a-pagination>
            </div>
        </div>
        <a-modal v-model="visibleDetail" title="任务详情" :footer='null' :maskClosable='false' width='1015px'>
            <div style="color:rgba(51, 51, 51, 1);font-size:16px;">任务详情</div>
            <div style="margin-top:16px;">
                <span style="display:inline-block;width:85px;color:rgba(153, 153, 153, 1);font-size:14px;">所属项目：</span>
                <span style="color:rgba(80, 80, 80, 1);font-size:14px;">{{detailData.projectName}}</span>
            </div>
            <div style="margin-top:16px;display:flex">
                <span style="display:inline-block;width:85px;color:rgba(153, 153, 153, 1);font-size:14px;">项目详情：</span>
                <span style="color:rgba(80, 80, 80, 1);font-size:14px;flex:1">{{detailData.projectDescription}}</span>
            </div>
            <div style="color:rgba(51, 51, 51, 1);font-size:16px;margin-top:40px">任务详情</div>
            <div style="margin-top:16px;">
                <div style="width:50%;display:inline-block">
                    <span style="display:inline-block;width:85px;color:rgba(153, 153, 153, 1);font-size:14px;">参与人数：</span>
                    <span style="color:rgba(80, 80, 80, 1);font-size:14px;">{{detailData.userCount}}</span>
                </div>
                <div style="width:50%;display:inline-block">
                    <span style="display:inline-block;width:85px;color:rgba(153, 153, 153, 1);font-size:14px;">话句数量：</span>
                    <span style="color:rgba(80, 80, 80, 1);font-size:14px;">{{detailData.wordCount}}条</span>
                </div>
            </div>
            <div style="margin-top:16px;">
                <div style="width:50%;display:inline-block">
                    <span style="display:inline-block;width:85px;color:rgba(153, 153, 153, 1);font-size:14px;">截止日期：</span>
                    <span style="color:rgba(80, 80, 80, 1);font-size:14px;">{{detailData.limitDate}}</span>
                </div>
                <div style="width:50%;display:inline-block">
                    <span style="display:inline-block;width:85px;color:rgba(153, 153, 153, 1);font-size:14px;">存疑单价：</span>
                    <span style="color:rgba(80, 80, 80, 1);font-size:14px;">￥{{detailData.priceDoubt}}</span>
                </div>
            </div>
            <div style="margin-top:16px;">
                <div style="width:50%;display:inline-block">
                    <span style="display:inline-block;width:85px;color:rgba(153, 153, 153, 1);font-size:14px;">正确单价：</span>
                    <span style="color:rgba(80, 80, 80, 1);font-size:14px;">￥{{detailData.priceRight}}</span>
                </div>
                <div style="width:50%;display:inline-block">
                    <span style="display:inline-block;width:85px;color:rgba(153, 153, 153, 1);font-size:14px;">错误单价：</span>
                    <span style="color:rgba(80, 80, 80, 1);font-size:14px;">
                        ￥{{detailData.priceError}}
                    </span>
                </div>
            </div>
            <div style="margin-top:16px;">
                <div style="display:flex;">
                    <span style="display:inline-block;width:85px;color:rgba(153, 153, 153, 1);font-size:14px;">意图列表：</span>
                    <div style="flex:1" class="intention-list2">
                        <div v-for="(item, index) in detailData.intentionNameList" :key="index">{{item}}</div>
                    </div>
                </div>
            </div>
            <div style="text-align:center">
                <span @click="continueTask()" style="width:100px;height:36px;text-align:center;line-height:36px;color:#fff;font-size:14px;background:rgba(24, 144, 255, 1);margin-top:35px;display:inline-block;border-radius:4px;cursor:pointer">继续任务</span>
            </div>
        </a-modal>
    </div>
</template>

<script>
export default {
    name: 'TaskManage',
    props: {
        msg: String
    },
    data() {
        return {
            visibleDetail: false,
            data: [],
            ifShowLoading: false,
            pageSizeOptions: ['10', '20', '50', '100'],
            total: 0,
            taskProgress: '',
            correctStatistics: '',
            taskCondition: {
                current: 1,
                size: 10,
                status: ''
            },
            detailData: '',
            taskId: '',
        } 
    },
    methods: {
        selectCondition(type) {
            this.taskCondition.status = type
            this.queryData()
        },
        viewTaskDetail(id) {
            this.visibleDetail = true
            this.taskId = id
            this.axios({
                url: '/api/user/task', 
                method: 'get',
                params: {
                    id: id,
                }
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.detailData = response.data.data
                }else{
                    this.$parent.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        continueTask() {
            this.visibleDetail = false
            this.$router.push({path: '/UserNav/MarkingTable',query:{taskId:this.taskId}});
        },
        queryData() {
            this.axios({
                url: '/api/user/task/list', 
                method: 'get',
                params: {
                    current: this.taskCondition.current,
                    size: this.taskCondition.size,
                    status: this.taskCondition.status,
                }
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.data = response.data.data.records
                    this.total = response.data.data.total
                }else{
                    this.$parent.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        onShowSizeChange(current, pageSize) {
            this.taskCondition.current = current
            this.taskCondition.size = pageSize;
            this.queryData()
        },
        onChangeSample(value) {
            this.taskCondition.current = value
            this.queryData()
        },
        myTaskProgress() {
            this.axios(
                {
                    method:'get',
                    url:'/api/user/statistic/user/task',
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    this.taskProgress = response.data.data
                }else{
                    this.$parent.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        accuracyStatistics() {
            this.axios(
                {
                    method:'get',
                    url:'/api/user/statistic/user/task/result',
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    this.correctStatistics = response.data.data
                }else{
                    this.$parent.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        judgeState(state) {
            switch(state) {
                case 'ON_GOING':
                    return '进行中'
                case 'TO_CHECK':
                    return '待验收'
                case 'FINISH':
                    return '已完成'
                case 'DELAY':
                    return '已延期'
            } 
        }
    },
    mounted: function() {
        this.myTaskProgress()
        this.accuracyStatistics()
        this.queryData()
    }
}
</script>

<style lang="less">
.my-task{
    padding: 24px;
    background: rgba(245, 246, 247, 1);
    .task-statistics{
        height: 210px;
        display: flex;
        .progress{
            flex: 1;
            color: rgba(80, 80, 80, 1);
            background-color: rgba(255, 255, 255, 1);
            border-radius: 4px;
            font-size: 14px;
            box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.04);
            text-align: center;
            margin-right: 16px;
            li{
                display: inline-block;
                width: 20%;
                float: left;
                margin-top:60px;
                color: rgba(170, 170, 170, 1);
                div:nth-child(1){
                    font-size: 28px;
                    font-weight: bold;
                }
            }
        }
        .statistics{
            width: 758px;
            color: rgba(80, 80, 80, 1);
            background-color: rgba(255, 255, 255, 1);
            border-radius: 4px;
            font-size: 14px;
            box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.04);
            .proportion{
                padding: 24px;
                div.list{
                    text-align: center;
                }
                span{
                    margin-right: 16px;
                }
            }
        }
    }
    .tast-list{
        margin-top: 16px;
        padding: 12px 0;
        background:#fff;
        box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.04);
        border-radius: 4px;
        .title{
            font-size: 16px;
            color: rgba(51, 51, 51, 1);
            display: inline-block;
        }
        .condition-list{
            float: right;
            span{
                display:inline-block;
                padding: 0 19px 14px 19px;
            cursor: pointer;
            }
            span:nth-child(5){
                padding: 0 0px 14px 19px;
            }
            span:nth-child(5).active{
                padding: 0 19px 14px 19px;
            }
            span.active{
                color: rgba(24, 144, 255, 1);
                border-bottom: 3px solid rgba(24, 144, 255, 1);
            }
        }
    }
  }
.intention-list2{
    div{
      display: inline-block;
      width: 200px;
      height: 32px;
      text-align: center;
      line-height: 32px;
      border: 1px solid rgba(229, 229, 229, 1);
      border-radius: 4px;
      margin-right: 16px;
      color: rgba(80, 80, 80, 1);
      margin-bottom: 16px;
      background: rgba(229, 229, 229, 1);
    }
    div:nth-child(4n){
      margin-right: 0px;
    }
}
</style>
